import clsx from 'clsx';
import React from 'react';
import { useResponsiveProp } from '../../utils';
export function TableHeader(props) {
    const { children, className, align, alignSelf, numeric, gridArea, style, hidden, ...rest } = props;
    const responsiveAlign = useResponsiveProp(align);
    return (React.createElement("th", { role: "columnheader", ...rest, className: clsx('mollie-ui-table-header', {
            [`mollie-ui-table-header--align-${responsiveAlign}`]: responsiveAlign,
            'mollie-ui-table-header--numeric': numeric,
        }, className), style: {
            ...style,
            gridArea: useResponsiveProp(gridArea),
            alignSelf: useResponsiveProp(alignSelf),
        }, hidden: useResponsiveProp(hidden) }, children));
}
TableHeader.displayName = 'Table.Header';
//# sourceMappingURL=TableHeader.js.map